import React from 'react';
import { HorizontalMenuModel } from 'types/model';
import { HorizontalMenu } from './menu';

type HorizontalMenuSetupProps = {
  disableHorizontalMenu?: boolean;
  model: HorizontalMenuModel;
};

export const HorizontalMenuSetup = ({ disableHorizontalMenu, model }: HorizontalMenuSetupProps) => {
  const { list, enable } = model;

  if (disableHorizontalMenu || !enable || list.length === 0) {
    return null;
  }

  return <HorizontalMenu list={list} />;
};
